import AbstractVertical from './AbstractVertical'

export default class Transient extends AbstractVertical {

  readonly name: string = 'transient'
  readonly title: string = 'Transient'
  readonly color: string = '#0077b2'
  readonly sortWeight: number = 40

  readonly supportedFeatures: string[] = [
    'showOnRateManagementCalendar',
    'editInventory',
    'limitedByWeekday',
    'showOnUniversalInventoryCalendar',
    'spotRates',
    'startAndEndTimes',
    'tieredRates',
  ]

}
